module.exports = __webpack_public_path__ + "static/zambia-a01602a33131f8e2a1caaec4d2fc0c11.svg";